<template>
    <credit-card-picker :customer="customer" ref="picker" name="token"></credit-card-picker>
</template>

<script>
  export default {
    props: {
      customer: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        initialValue: this.$store.state.checkout.shipping.address,
      }
    },
    methods: {
      validate() {
        return this.$refs.picker.validate();
      },
      getData() {
        return this.$refs.picker.getValues();
      }
    },
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/ecommerce/assets/js/components/checkout/payment/CreditCardHandler.vue